import React, { forwardRef } from 'react';
import { styled } from '@compiled/react';
import { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import { token } from '@atlaskit/tokens';
import { ENTRYPOINT_ID_JIRA_PLATFORM } from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { FeedbackCollectorButton } from '@atlassian/jira-feedback-collector/src/ui/button/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as Section } from './section/view.tsx';

export const FeedbackCollector = () => (
	<FeedbackCollectorButton
		entrypointId={ENTRYPOINT_ID_JIRA_PLATFORM}
		feedbackGroupId="personal-settings-sidebar"
	/>
);

const TextBreadcrumbItem = forwardRef((_props, _ref) => {
	const { formatMessage } = useIntl();

	return (
		<PlainBreadcrumbItem>{formatMessage(messages.personalSettingsBreadcrumb)}</PlainBreadcrumbItem>
	);
});

export const PersonalSettingsBreadcrumbItem = () => (
	<BreadcrumbsItem component={TextBreadcrumbItem} text="" />
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PlainBreadcrumbItem = styled.span({
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest'),
	paddingBlock: token('space.025'),
});
